import styled from '@emotion/styled';
import InputLabel from '@mui/material/InputLabel';

export const Container = styled(InputLabel)``;
